import { render, staticRenderFns } from "./ListClaimArsip.vue?vue&type=template&id=8cd96a10"
import script from "./ListClaimArsip.vue?vue&type=script&lang=js"
export * from "./ListClaimArsip.vue?vue&type=script&lang=js"
import style0 from "./ListClaimArsip.vue?vue&type=style&index=0&id=8cd96a10&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports